import { render, staticRenderFns } from "./ItemListStyle2.vue?vue&type=template&id=78eba6c7&scoped=true"
import script from "./ItemListStyle2.vue?vue&type=script&lang=js"
export * from "./ItemListStyle2.vue?vue&type=script&lang=js"
import style0 from "./ItemListStyle2.vue?vue&type=style&index=0&id=78eba6c7&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78eba6c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78eba6c7')) {
      api.createRecord('78eba6c7', component.options)
    } else {
      api.reload('78eba6c7', component.options)
    }
    module.hot.accept("./ItemListStyle2.vue?vue&type=template&id=78eba6c7&scoped=true", function () {
      api.rerender('78eba6c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/modules/phone/common/ItemListStyle2.vue"
export default component.exports